import { ReactNode, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import i18next from "../i18n"; // Import i18next instance

// Load locales files
const loadLocaleData = (locale: string) => {
  switch (locale) {
    case "vi":
      return import("../locales/vi.json");
    case "en":
    default:
      return import("../locales/en.json");
  }
};

// ==============================|| LOCALIZATION ||============================== //

interface Props {
  children: ReactNode;
}

const Locales = ({ children }: Props) => {
  const [messages, setMessages] = useState<Record<string, string> | undefined>();

  useEffect(() => {
    // Load initial language data
    loadLocaleData(i18next.language).then((d) => {
      setMessages(d.default as Record<string, string>);
    });

    // Listen for language changes
    const handleLanguageChange = (lng: string) => {
      loadLocaleData(lng).then((d) => {
        setMessages(d.default as Record<string, string>);
      });
    };

    i18next.on("languageChanged", handleLanguageChange);

    // Cleanup listener on unmount
    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, []);

  // Show loading state if messages aren't loaded
  if (!messages) {
    return <div>Loading translations...</div>;
  }

  return (
    <IntlProvider locale={i18next.language} defaultLocale="vi" messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default Locales;
